import axios from "axios";

// 운영계
export default axios.create({ baseURL: "https://was.askgileadmedicalregistration.co.kr",withCredentials: true});
// 개발계
// export default axios.create({ baseURL: "https://was.logintoaskgileadmedical.co.kr",withCredentials: true});
// export default axios.create({ baseURL: "http://localhost:6501",withCredentials: true});
